import axios from "utils/axios";
import { LOOKUP_VENDOR_MAKES_URL } from "config/services";

export const lookupVendorMakes = async (subCategoryIds, selectedMakeIds, signal) => {
  const response = await axios.post(LOOKUP_VENDOR_MAKES_URL, { subCategoryIds, selectedMakeIds }, { signal, timeout: 10000 });
  const data = response.data?.data;
  if (!data?.bySubCategory || !Array.isArray(data.selectedMakes)) throw new Error("Unable to load make options.");
  return data;
};

export const materialMakeSelections = (hierarchy = [], taxonomy = {}) => {
  const selected = new Map();
  for (const type of hierarchy) if (type.vendorType === "Material") {
    for (const discipline of type.disciplines || []) for (const category of discipline.categories || []) {
      for (const sub of category.subCategories || []) selected.set(String(sub.subCategoryId), sub.makeIds || []);
    }
  }
  const result = [];
  for (const discipline of taxonomy.Material?.disciplines || []) for (const category of discipline.categories || []) {
    for (const sub of category.subCategories || []) if (selected.has(String(sub._id))) {
      result.push({ subCategoryId: String(sub._id), label: sub.name, path: `${discipline.name} / ${category.name}`, makeIds: selected.get(String(sub._id)).map(String) });
    }
  }
  return result;
};

export const makeSelectionMap = (hierarchy = []) => {
  const result = {};
  for (const type of hierarchy) for (const discipline of type.disciplines || []) {
    for (const category of discipline.categories || []) for (const sub of category.subCategories || []) {
      if (Object.prototype.hasOwnProperty.call(sub, "makeIds")) result[String(sub.subCategoryId)] = [...sub.makeIds];
    }
  }
  return result;
};
